import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import moment from 'moment';
import { Image } from 'react-bootstrap';
import SuperAdminDeleteOffer from '../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import ReadMoreReact from 'read-more-react';
// import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import ViewOfferDetailsOffline from './ViewOfferDetailsOffline';
import ViewOfferDetailsOnline from './ViewOfferDetailsOnline';
import ActiveDeactiveEventsAndOffers from '../../reusableComponents/allPopupReusable/offerEventPopup/ActiveDeactiveEventsAndOffers';
import ShareLinkModal from '../../reusableComponents/ShareLinkModal';
// import ViewOfferDetailsOffline from "../../superAdminComponents/superAdminAllComponent/superAdminUsers/insidePageComponent/FavoritesPageInsideComponent/ViewOfferDetailsOffline";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const OfferManagementTableBody = (props) => {
  const history = useHistory();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const onHandleRedirect = (data) => (e) => {
    if (data.isOnline) {
      history.push({
        pathname: `/offer/edit-online-offer/${data._id}`,
        state: { editData: data },
      });
    } else {
      history.push({
        pathname: `/offer/edit-offline-offer/${data._id}`,
        state: { editData: data },
      });
    }
  };

  return (
    <tbody>
      <tr className="super_admin_all_users_table_body">
        <td colSpan="7" className="p-0 w-100">
          <table className="w-100 HideShowTable enMinWidth900">
            <tbody>
              <tr className="cursor" onClick={showTr}>
                <td
                  style={{ width: '25%' }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div
                      className="text-center d-flex flex-column align-items-center"
                      style={{ width: '20%' }}
                    >
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <div className="enIMG33 rounded">
                            <Image
                              src={props.data && props.data.photos[0]}
                              alt="View"
                              title="View"
                              className="w-100 h-100"
                            />
                          </div>
                        </SRLWrapper>
                      </SimpleReactLightbox>
                      <div
                        className={`${
                          props.data && props.data.isOnline
                            ? 'enSuccessLBL mt-2'
                            : 'enPendingLBL mt-2'
                        }`}
                      >
                        {props.data && props.data.isOnline
                          ? 'Online'
                          : 'Offline'}
                      </div>
                      {/* enSuccessLBL */}
                    </div>
                    <div className="pl-3">
                      <div className="f12-500">
                        {props.data && props.data.name}
                      </div>
                      <div className="f9-400 mt-1 mb-1">
                        #{props?.data?._id}
                      </div>
                      <div id="read-more-text" className="f10-500 opacity5">
                        <ReadMoreReact
                          text={props.data && props.data.description}
                          min={0}
                          ideal={0}
                          max={props.data && props.data.description.length}
                          readMoreText={'Read More'}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: '13%' }}>
                  <div className="f12-500">
                    {moment(props.data.start_date).format('Do MMM YYYY')}
                  </div>
                </td>
                <td style={{ width: '13%' }}>
                  <div className="f12-500 text-red">
                    {moment(props.data.end_date).format('Do MMM YYYY')}
                  </div>
                </td>
                <td style={{ width: '12%' }}>
                  <div className="f12-500">{props.data.type}</div>
                </td>
                <td style={{ width: '10%' }}>
                  <div className="f14-500">
                    {props.data.isPercentage ? props.data.discount : '-'}
                  </div>
                </td>
                <td style={{ width: '14%' }}>
                  <div className="f15-700">
                    {props.data.isOnline
                      ? !props.data.isPercentage
                        ? props.data.discount
                        : '-'
                      : '-'}
                  </div>
                </td>
                <td style={{ width: '13%' }}>
                  {props.data?.isOnline
                    ? props.data.hidden
                      ? 'Yes'
                      : 'No'
                    : '-'}
                </td>
                <td
                  style={{ width: '13%' }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div className="f14-500 mr-2">
                      {props.data.active ? 'Active' : 'Inactive'}
                    </div>
                    <ActiveDeactiveEventsAndOffers
                      diameter={24}
                      height={15}
                      width={41}
                      activeProps={props.data}
                      displayActive={true}
                      actionButton="offers"
                    />
                  </div>
                </td>
                <td
                  style={{ width: '13%' }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div
                      className={`${
                        !props.data.mark_as_primary
                          ? 'f14-500 mr-2'
                          : 'f14-400 mr-2'
                      }`}
                    >
                      No
                    </div>
                    <ActiveDeactiveEventsAndOffers
                      diameter={24}
                      height={15}
                      width={41}
                      activeProps={props.data}
                      displayPrimary={true}
                      actionButton="offers"
                    />
                    <div
                      className={`${
                        props.data.mark_as_primary
                          ? 'f14-500 mr-2'
                          : 'f14-400 mr-2'
                      }`}
                    >
                      Yes
                    </div>
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <React.Fragment>
                  <tr className="border-top">
                    <td style={{ width: '25%' }}>
                      <div className="f12-500 text-red mb-3">More details</div>
                      <div className="d-flex align-items-center">
                        {props.data.isOnline ? (
                          <ViewOfferDetailsOnline vendorOffer={props.data} />
                        ) : (
                          <ViewOfferDetailsOffline vendorOffer={props.data} />
                        )}
                        <div
                          className="enIconBtn mr-3"
                          onClick={onHandleRedirect(props.data)}
                        >
                          <Image
                            src={require('../../../assets/images/UserManagement/pencil.svg')}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                        <SuperAdminDeleteOffer
                          actionBy={'vendor'}
                          offerId={props.data._id}
                        />
                        <ShareLinkModal
                          userAppLink={props.data?.shareLink?.shortLink || ''}
                          webAppHide={true}
                        />
                      </div>
                    </td>
                    <td style={{ width: '13%' }}>
                      <div className="f12-500 mb-3">Views</div>
                      <div className="f14-400 ">{props.data.offerViews}</div>
                    </td>
                    <td style={{ width: '12%' }}>
                      <div className="f12-500 mb-3">Used</div>
                      <div className="f14-400 enEllips">
                        {props.data.offerUsed}
                      </div>
                    </td>
                    <td style={{ width: '10%' }}>
                      <div className="f12-500 mb-3">Offer Code</div>
                      <div className="f14-400 enEllips">
                        {props.data.coupon_code}
                      </div>
                    </td>
                    <td style={{ width: '30%' }}>
                      <div className="f12-500 mb-3">Offer Code Usage Limit</div>
                      <div className="f14-400 enEllips">
                        {props.data?.maximum_usage_limit !== undefined &&
                        props?.data?.maximum_usage_limit !== null &&
                        props?.data?.maximum_usage_limit !== ''
                          ? props?.data?.maximum_usage_limit
                          : '-'}
                      </div>
                    </td>
                    <td style={{ width: '30%' }}>
                      <div className="f12-500 mb-3">Applicable To Services</div>
                      <div className="f14-400 enEllips">
                        {props.data &&
                          props.data.service_type.map((data, index) => {
                            return (
                              <React.Fragment key={index}>
                                {data},{' '}
                              </React.Fragment>
                            );
                          })}
                      </div>
                    </td>
                  </tr>
                  {props.data && props.data.isOnline ? (
                    <tr className="border-top">
                      <td style={{ width: '15%' }}>
                        <div className="f12-500 mb-3">Min. Order Value</div>
                        <div className="f14-400 ">
                          {props?.data?.minimum_order_applied !== undefined &&
                          props?.data?.minimum_order_applied !== null &&
                          props?.data?.minimum_order_applied !== ''
                            ? `₹ ${props?.data?.minimum_order_applied}`
                            : `-`}
                        </div>
                      </td>
                      <td style={{ width: '15%' }}>
                        <div className="f12-500 mb-3">Max. Order Value</div>
                        <div className="f14-400 enEllips">
                          {props?.data?.maximum_order_applied !== undefined &&
                          props?.data?.maximum_order_applied !== null &&
                          props?.data?.maximum_order_applied !== ''
                            ? `₹ ${props?.data?.maximum_order_applied}`
                            : `-`}
                        </div>
                      </td>
                      <td style={{ width: '15%' }}>
                        <div className="f12-500 mb-3">Max. Discount Value</div>
                        <div className="f14-400 enEllips">
                          {props?.data?.maximum_discount_applied !==
                            undefined &&
                          props?.data?.maximum_discount_applied !== null &&
                          props?.data?.maximum_discount_applied !== ''
                            ? `₹ ${props?.data?.maximum_discount_applied}`
                            : `-`}
                        </div>
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
